import React from 'react'
import { Link } from 'react-router-dom'
import { HubspotFormOLO } from '../../components/HubspotEmbed'

const Section8 = () => {
  return (
    <div className='s8-partner' id='becomeAPartner'>
        <div className='f-width m-auto'>
            <div className="blur-color-1 rounded-pill"></div>
            <div className="blur-color-2 rounded-pill"></div>
            <p className="s4-h-text text-center">Referral form</p>
            {/* <p className='s6-card-t2 text-center text-gray mb-0'>Complete the application below. Our team will be in touch within 24 hours.</p> */}
            <div className='row'>
                <div className="col-lg-12 text-center form-section">
                    <div className='rounded' style={{ maxWidth: "550px", margin: "auto", backgroundColor: "#F6F8FA" }}>
                        <HubspotFormOLO />
                    </div>
                </div>
            </div>
        </div>
        <div className='text-center p-footer' style={{backgroundColor: "#00000010"}}>
            <p className='mb-0 s6-card-t2'>For partnership inquiries, contact <Link to={"mailto:bilal@voosh.ai"}>bilal@voosh.ai</Link></p>
            {/* <p className='mb-0 s6-card-t2'>@ 2025 Voosh Al. All rights reserved</p> */}
        </div>
    </div>
  )
}

export default Section8